import "core-js/modules/es.array.map";
import "core-js/modules/es.string.trim";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createBairunCountryPrice, deleteBairunCountryPrice as _deleteBairunCountryPrice, deleteBairunCountryPriceByIds, updateBairunCountryPrice, findBairunCountryPrice, getBairunCountryPriceList } from '@/api/bairun/bairunCountryPrice'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { getDict } from '@/utils/dictionary'; // 获取字典数据的func

import { regionData } from 'element-china-area-data'; // 省市区联动

import * as DateUtil from '@/utils/date';

var _this;

export default {
  name: 'BairunCountryPrice',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    formatOilCodeText: function formatOilCodeText(text) {
      if (text != null) {
        return text + '#';
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      regionData: regionData,
      cityData: [],
      oilCodeDict: getDict('oilCode'),
      didChooseProvinceId: '',
      didChooseCityId: '',
      cityDisable: true,
      listApi: getBairunCountryPriceList,
      dialogFormVisible: false,
      type: '',
      deleteVisible: false,
      multipleSelection: [],
      oilCodeOptions: [],
      // 设置只能选择当前日期及之后的日期
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          // 如果没有后面的-8.64e7就是不可以选择今天的
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      formData: {
        provinceName: '',
        cityName: '',
        oilCode: 92,
        countryPrice: 0,
        startTime: new Date().Format('yyyy-MM-dd hh:mm:ss'),
        sysUserId: 0,
        sysUserName: '',
        whenStartRadio: 'now'
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.getTableData();

              case 2:
                _this3.setoilCodeMap();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData(); // console.log(this.regionData)
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    deleteRow: function deleteRow(row) {
      var _this4 = this;

      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.deleteBairunCountryPrice(row);
      }).catch(function (err) {});
    },
    onDelete: function onDelete() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var ids, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                ids = [];

                if (!(_this5.multipleSelection.length === 0)) {
                  _context4.next = 4;
                  break;
                }

                _this5.$message({
                  type: 'warning',
                  message: '请选择要删除的数据'
                });

                return _context4.abrupt("return");

              case 4:
                _this5.multipleSelection && _this5.multipleSelection.map(function (item) {
                  ids.push(item.ID);
                });
                _context4.next = 7;
                return deleteBairunCountryPriceByIds({
                  ids: ids
                });

              case 7:
                res = _context4.sent;

                if (!(res.code === 0)) {
                  _context4.next = 14;
                  break;
                }

                _this5.$message({
                  type: 'success',
                  message: '删除成功'
                });

                if (_this5.tableData.length === ids.length) {
                  _this5.page--;
                }

                _this5.deleteVisible = false;
                _context4.next = 14;
                return _this5.getTableData();

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    updateBairunCountryPrice: function updateBairunCountryPrice(row) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return findBairunCountryPrice({
                  ID: row.ID
                });

              case 2:
                res = _context5.sent;
                _this6.type = 'update';

                if (res.code === 0) {
                  _this6.formData = res.data.resBairunCountryPrice;
                  _this6.formData.startTime = new Date(_this6.formData.startTime).Format('yyyy-MM-dd hh:mm:ss');
                  _this6.formData.provinceId = _this6.formData.provinceId + '';
                  _this6.formData.cityId = _this6.formData.cityId + '';
                  _this6.formData.whenStartRadio = 'later';
                  _this6.dialogFormVisible = true;

                  _this6.didChangeProvince(_this6.formData.provinceId);

                  _this6.didChangeCity(_this6.formData.cityId);
                }

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.formData = {
        provinceId: '0',
        cityId: '0',
        provinceName: '',
        cityName: '',
        oilCode: 92,
        countryPrice: 0,
        startTime: new Date().Format('yyyy-MM-dd hh:mm:ss'),
        sysUserId: 0,
        sysUserName: '',
        whenStartRadio: 'now'
      };
    },
    deleteBairunCountryPrice: function deleteBairunCountryPrice(row) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _deleteBairunCountryPrice({
                  ID: row.ID
                });

              case 2:
                res = _context6.sent;

                if (res.code === 0) {
                  _this7.$message({
                    type: 'success',
                    message: '删除成功'
                  });

                  if (_this7.tableData.length === 1) {
                    _this7.page--;
                  }

                  _this7.getTableData();
                }

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    enterDialog: function enterDialog() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var that, paramm, res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                that = _this8;
                paramm = JSON.parse(JSON.stringify(_this8.formData));

                if (!(paramm.countryPrice <= 0)) {
                  _context7.next = 5;
                  break;
                }

                _this8.$message({
                  message: '国家价必须大于0',
                  type: 'warning'
                });

                return _context7.abrupt("return");

              case 5:
                if (!(paramm.startTime.trim() === '')) {
                  _context7.next = 8;
                  break;
                }

                _this8.$message({
                  message: '生效时间不能为空',
                  type: 'warning'
                });

                return _context7.abrupt("return");

              case 8:
                paramm.provinceId = parseInt(paramm.provinceId);
                paramm.cityId = parseInt(paramm.cityId);
                _context7.t0 = _this8.type;
                _context7.next = _context7.t0 === 'create' ? 13 : _context7.t0 === 'update' ? 17 : 21;
                break;

              case 13:
                _context7.next = 15;
                return createBairunCountryPrice(paramm);

              case 15:
                res = _context7.sent;
                return _context7.abrupt("break", 22);

              case 17:
                _context7.next = 19;
                return updateBairunCountryPrice(paramm);

              case 19:
                res = _context7.sent;
                return _context7.abrupt("break", 22);

              case 21:
                return _context7.abrupt("break", 22);

              case 22:
                if (!(res.code === 0)) {
                  _context7.next = 27;
                  break;
                }

                _this8.$message({
                  type: 'success',
                  message: '创建/更改成功'
                });

                _this8.closeDialog();

                _context7.next = 27;
                return _this8.getTableData();

              case 27:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    openDialog: function openDialog() {
      this.type = 'create';
      this.dialogFormVisible = true;
      this.onStartTimeSwitch();
    },
    setoilCodeMap: function setoilCodeMap() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return getDict('oilCode');

              case 2:
                _this9.oilCodeDict = _context8.sent;

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    didChangeProvince: function didChangeProvince(val) {
      // 筛选出相应的城市
      // console.log(val)
      this.didChooseProvinceId = val; // console.log(this.didChooseCityId)

      if (this.didChooseProvinceId.length > 0 && this.didChooseCityId.length > 0) {
        this.searchInfo.cityId = '';
      }

      if (this.didChooseProvinceId.length > 0) {
        this.cityDisable = false;
      } else {
        this.cityDisable = true;
        this.searchInfo.cityId = '';
      }

      for (var i = 0; i < this.regionData.length; i++) {
        if (regionData[i].value === val) {
          this.cityData = regionData[i].children;
          this.formData.provinceName = regionData[i].label; // console.log(this.cityData)

          break;
        }
      }
    },
    didChangeCity: function didChangeCity(val) {
      // console.log(val)
      this.didChooseCityId = val;
      this.formData.cityId = val;

      for (var i = 0; i < this.cityData.length; i++) {
        if (this.cityData[i].value === val) {
          this.formData.cityName = this.cityData[i].label;
          break;
        }
      }
    },
    onStartTimeSwitch: function onStartTimeSwitch() {
      if (this.formData.whenStartRadio === 'now') {
        this.formData.startTime = new Date().Format('yyyy-MM-dd hh:mm:ss');
      }

      if (this.formData.whenStartRadio === 'later') {
        this.formData.startTime = DateUtil.diffDate(1);
      }

      this.$forceUpdate();
    }
  }
};